<template>
  <div class="mf-Ueditor">
    <vue-ueditor-wrap v-model="details" :config="myConfig" :destroy="false" @ready="ready"></vue-ueditor-wrap>
  </div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
  name: 'Ueditor',
  components: {
    VueUeditorWrap
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: String
  },
  data() {
    return {
      details: '',
      myConfig: {
        // 如果需要上传功能,找后端小伙伴要服务器接口地址
        // serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
        serverUrl: this.getFwbFileUrl(),
        // 你的UEditor资源存放的路径,相对于打包后的index.html
        UEDITOR_HOME_URL: '/UEditor/',
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 工具栏是否可以浮动
        autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 关闭自动保存
        enableAutoSave: true
      }
    }
  },
  watch: {
    value(val) {
      this.details = val
    },
    details(val) {
      this.$emit('change', val)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getLogUtils().logWithTag('serverUrl', this.myConfig.serverUrl)
    })
  },
  methods: {
    //获取图片上传地址
    getFwbFileUrl() {
      let appConfig = this.getAppConfig()
      this.getLogUtils().logWithTag('serverUrl', appConfig)
      return appConfig.fwbUrl
    },
    ready(editorInstance) {
      this.$emit('ready', editorInstance)
    }
  }
}
</script>
<style>
.edui-default .edui-editor-toolbarbox {
  line-height: normal;
}
</style>

